export default __webpack_public_path__ + "static/media/Tronlink.534d893e.png";